import type { ApolloCache } from '@apollo/client';

import type { GetPropertyImagesCountQuery } from '@graphql/__generated__/graphql';
import { GET_PROPERTY_IMAGES_COUNT } from '@modules/listings/ListingPropertyImages/listingPropertyQueries';

export const updatePropertyImagesCountCache = (
  cache: ApolloCache,
  propertyId: string,
  delta: number,
) => {
  const queryOptions = {
    query: GET_PROPERTY_IMAGES_COUNT,
    variables: { property_id: propertyId },
  };
  const current = cache.readQuery<GetPropertyImagesCountQuery>(queryOptions);
  const aggregate = current?.property_images_aggregate.aggregate;

  if (current == null || aggregate == null) {
    return;
  }

  cache.writeQuery<GetPropertyImagesCountQuery>({
    ...queryOptions,
    data: {
      property_images_aggregate: {
        ...current.property_images_aggregate,
        aggregate: {
          ...aggregate,
          count: Math.max(0, aggregate.count + delta),
        },
      },
    },
  });
};
